import React from "react";
import PropTypes from "prop-types";
import sanitizeHtml from "sanitize-html";
import { Container } from "semantic-ui-react";

/**
 * Imports the timetable stylesheet.
 */
import "./Timetable.css";

/**
 * Sanitizes an HTML-string provided by the server before
 * outputting safely using sanitize-html, only allowing specific
 * tags and attributes.
 *
 * @param {String} html
 */
const sanitize = html =>
  sanitizeHtml(html, {
    allowedTags: ["b", "strong", "table", "tr", "td", "th", "span", "br"],
    allowedAttributes: {
      "*": ["class"],
      td: ["colspan", "rowspan"],
      th: ["colspan", "rowspan"],
      br: ["clear"]
    }
  });

/**
 * TimetableView: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Renders the current timetable and sanitizes the output beforehand
 * for improved security.
 *
 * @param {*} props
 */
const TimetableView = props => (
  <Container>
    {/**
     * dangerouslySetInnerHTML is used, but the HTML is sanitized beforehand
     * enforcing strict allowed tags and attributes
     */}
    <div
      className="ag-timetable-view"
      dangerouslySetInnerHTML={{ __html: sanitize(props.currentTimetable) }}
    />
  </Container>
);

TimetableView.propTypes = {
  /**
   * currentTimetable: String
   * Current timetable data which will be sanitized and displayed
   */
  currentTimetable: PropTypes.string.isRequired
};

export default TimetableView;



// WEBPACK FOOTER //
// ./src/modules/agenda/timetable/TimetableView.js